import { render, staticRenderFns } from "./StepSignatureEmail.vue?vue&type=template&id=15fa6870"
import script from "./StepSignatureEmail.vue?vue&type=script&lang=js"
export * from "./StepSignatureEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports